module.exports = __webpack_public_path__ + "f595a8699c1563187b586d049bce54cf.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2021-12-07/whats-new.html
// module id = 2326
// module chunks = 0